import {BaseContainerModel} from '../../base-container.model';
import {
  bl_cms_calendar_event_company_link_RowClass,
} from '../../../dbschema';

export class CalenderEventCompanyLinkContainerModel extends BaseContainerModel {
  bl_cms_calendar_event_company_link: bl_cms_calendar_event_company_link_RowClass = new bl_cms_calendar_event_company_link_RowClass();
}